import { create } from "zustand";
import { verifyOtpResponse } from "@/lib/types/DTO/core/auth";
import { login } from "../helper";

type OtpVerified = {
  mobile: string;
  otp: string;
};

type AuthState = {
  otpVerified?: OtpVerified;
  verifyOtp: (args: {
    mobile: string;
    otp: string;
    account: verifyOtpResponse;
  }) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  otpVerified: undefined,

  verifyOtp: ({ account, ...data }) => {
    // store OTP data
    set({ otpVerified: data });

    // login
    login({ ...account });
  },
}));
